import {makeInstaller} from 'element-plus/es/make-installer.mjs';
import Components from 'element-plus/es/component.mjs';
import {ElInfiniteScroll} from 'element-plus/es/components/infinite-scroll/index.mjs';
import {ElLoading} from 'element-plus/es/components/loading/index.mjs';
import {ElMessage} from 'element-plus/es/components/message/index.mjs';
import {ElMessageBox} from 'element-plus/es/components/message-box/index.mjs';
import {ElPopoverDirective} from 'element-plus/es/components/popover/index.mjs';
import de from 'element-plus/es/locale/lang/de'
import '@/assets/scss/element.scss'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(makeInstaller([
        ...Components,
        ElInfiniteScroll,
        ElLoading,
        ElMessage,
        ElMessageBox,
        ElPopoverDirective
    ]), {
        locale: de,
        size: 'large'
    })
})
